import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileActivityService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  getActivityLogs(params: {
    searchText: string;
    fileSystemId: string;
    fromDate: string;
    toDate: string;
    pageSize: number;
  }): Observable<any> {
    return this.#http.getData<any>(
      `${this.baseUrl}/filesystemactivity?SearchText=${params.searchText}&fileSystemID=${params.fileSystemId}&fromDate=${params.fromDate}&toDate=${params.toDate}&IsValidDateRange=true&PageSize=${params.pageSize}`,
      { showLoader: false, showMessage: false, showError: false }
    );
  }

  getRecentFolders(): Observable<any> {
    return this.#http.getData<any>(`${this.baseUrl}/filesystemactivity/recentfolders`, {
      showLoader: false,
      showMessage: false
    });
  }
}
